(function () {
  "use strict";

  // ----------------------------------------------------------------------------------------------------------------
  // GOKWIK COLLECTION/HOME PAGE ADD-TO-CART SIDE-CART SUPPRESSION
  // ----------------------------------------------------------------------------------------------------------------
  //
  // Gokwik's own hosted SDK (https://kwikcart.gokwik.co/kwikcart/side-cart.js) calls
  // window.openGokwikSideCart() itself after every add-to-cart, entirely independent of this
  // theme's code — confirmed via its own stack trace, which shows the call originating from
  // inside that external script, not from anything in this theme. It has no concept of "PDP vs
  // collection page", and there is no documented Gokwik config to suppress it from our side.
  // The theme's own cart:change event (which the native <cart-drawer> gate in
  // assets/cart-drawer-gate.js keys off of via event.detail.source) also does NOT fire for these
  // adds — Gokwik's SDK intercepts the add before the theme's own ProductForm submit handler
  // gets a chance to dispatch it (this is also why cart-savings-bar.liquid and product-card.liquid
  // had to start listening for Gokwik's own cart:refresh event instead).
  //
  // So the only lever available is: watch for the click ourselves (passively — never call
  // preventDefault/stopPropagation, so Gokwik's own handling is never interfered with), and if it
  // came from a collection/home-page product-card (data-atc-source="collection_page" — same
  // attribute/value the native drawer gate and addon-global-shared-logic.liquid already use),
  // close the side-cart the moment it actually mounts. PDP adds are left completely alone.
  //
  // Shadow-DOM detection helpers mirror assets/cart-drawer-gate.js for consistency.

  var pendingSuppressUntil = 0;
  var SUPPRESS_ARMING_MS = 4000; // generous window between the click and Gokwik's own async open

  document.addEventListener(
    "click",
    function (event) {
      var submitControl = event.target.closest && event.target.closest('[type="submit"]');
      if (!submitControl) return;

      var form = submitControl.closest("form");
      if (!form || !form.action || form.action.indexOf("/cart/add") === -1) return;

      var sourceEl = submitControl.closest("[data-atc-source]");
      var source = sourceEl ? sourceEl.getAttribute("data-atc-source") : null;

      if (source === "collection_page") {
        pendingSuppressUntil = Date.now() + SUPPRESS_ARMING_MS;
      }
    },
    true
  );

  function getShadowRoot() {
    var container = document.querySelector("shadow-dom-container");
    return container ? container.shadowRoot : null;
  }

  function sidecartMounted() {
    var sr = getShadowRoot();
    return sr ? !!sr.querySelector(".sidecart") : false;
  }

  var wasMounted = sidecartMounted();

  setInterval(function () {
    var isMounted = sidecartMounted();

    if (isMounted && !wasMounted && Date.now() < pendingSuppressUntil) {
      window.closeGokwikSideCart?.();
      pendingSuppressUntil = 0;
    }

    wasMounted = isMounted;
  }, 100);
})();
